import { useEffectOnce } from 'react-use';

/** Auto-scrolls to top of the page when first rendered */
export const useAutoScrollToTop = () => {
  useEffectOnce(() => {
    window.scrollTo(0, 0);
  });
};
